import { render, staticRenderFns } from "./CoverLayerIcon.vue?vue&type=template&id=4fad7368&"
import script from "./CoverLayerIcon.vue?vue&type=script&lang=js&"
export * from "./CoverLayerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports